/**
 * Builds a viewable URL for a segment picture.
 *
 * Segments store the Contabo object key ("magic-lamp/1785827387533-6b59….jpg"),
 * not a URL — the same approach the refund module uses, so nothing depends on
 * the portal's CONTABO_PUBLIC_URL, which is missing the tenant prefix Contabo
 * needs and returns 401.
 *
 * The base URL lives in the front end instead:
 *   REACT_APP_CONTABO_UPLOADS_BASE_URL
 *     = https://sin1.contabostorage.com/<tenantId>:<bucket>
 *
 * Segments saved before this change hold a full URL built from that broken
 * base. Passing those through unchanged would keep showing a 401, so the object
 * key is recovered from them and rebuilt against the working base — old rows
 * display correctly with no data migration.
 */
const BASE = (process.env.REACT_APP_CONTABO_UPLOADS_BASE_URL || '').replace(/\/+$/, '');

export default function imageSrc(keyOrUrl) {
  if (!keyOrUrl) return null;

  const raw = String(keyOrUrl).trim();
  if (!raw) return null;

  // With no configured base, only an absolute URL is any use.
  if (!BASE) return /^https?:\/\//i.test(raw) ? raw : null;

  // The bucket is the part after the tenant id: "<tenantId>:<bucket>".
  const bucket = BASE.split(':').pop();
  const marker = `/${bucket}/`;

  // A legacy value contains "/<bucket>/" partway through; everything after it
  // is the object key. A fresh value is already just the key.
  const at = raw.indexOf(marker);
  const key = at === -1 ? raw : raw.slice(at + marker.length);

  // An absolute URL pointing somewhere else entirely is left alone.
  if (/^https?:\/\//i.test(key)) return key;

  return `${BASE}/${key.replace(/^\/+/, '')}`;
}
